export class Routes {
    public static LOGIN_ROUTE = "/login";
    public static REGISTER_ROUTE = "/register";
    public static DASHBOARD_ROUTE = "/dashboard";
}
